import { render, staticRenderFns } from "./View-Pdf.vue?vue&type=template&id=458f0b7a&scoped=true&"
import script from "./View-Pdf.vue?vue&type=script&lang=js&"
export * from "./View-Pdf.vue?vue&type=script&lang=js&"
import style0 from "./View-Pdf.vue?vue&type=style&index=0&id=458f0b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f0b7a",
  null
  
)

export default component.exports